import { Point } from "../models/Point";
import { EncodingUtils } from "../utils/EncodingUtils";
import { SvgUtils } from "../utils/SvgUtils";
import { VisualizerBase } from "./VisualizerBase";

export class PGN extends VisualizerBase {
    constructor(_placeholderMode: boolean = false) {
        super("pgn", _placeholderMode);
    }
    
    public override generate(hex: string, coreMode: boolean = false): SVGSVGElement {
        const svg = this.createSvg();
        //this.appendBlendStyle(svg);
        this.hexArray = EncodingUtils.hexStringToHexArray(hex);

        const size = 320;
        const center = size / 2;
        const R = 40;
        const r0 = 100;
        const height = 40, halfH = height / 2;
        const pX = halfH * Math.tan(24 * Math.PI / 180);

        const defs = document.createElementNS("http://www.w3.org/2000/svg", "defs");

        const color1 = this.getColorHex(1, 2, 3);
        const color2 = this.getColorHex(4, 5, 6);
        const color3 = this.getColorHex(7, 8, 9);
        
        const idOB = `circleOutbounding_${this.chainIdName}`;
        const dOB = SvgUtils.getDOfPathOfCircle(0, 0, 150);
        const obCircle = document.createElementNS("http://www.w3.org/2000/svg", "path");
        obCircle.id = idOB;
        obCircle.setAttribute("d", `${dOB}`);
        defs.appendChild(obCircle);

        const idCircleBig = `circle_big_${this.chainIdName}`;
        const circleBig = SvgUtils.drawCircle0(idCircleBig, 0, -r0, R);
        defs.appendChild(circleBig);

        const points: Array<Point> = [ new Point(0, -r0 + halfH),
            new Point(-pX, -r0),
            new Point(0, -r0 - halfH),
            new Point(pX, -r0)
        ];
        const polygonId = `polygon_48deg_80_${this.chainIdName}`;
        const polygon = SvgUtils.createPolygonPath(polygonId, points, true, ``, "", 0);
        defs.appendChild(polygon);

        svg.appendChild(defs);

        if(!coreMode) {
            // outbound: moving 3 circles
            this.appendMovingCirclesOutbound(svg, 150);
            // outbound: scaling circle
            this.appendDynamicScalingOutbound(svg, 1.4);
        }

        const group = document.createElementNS("http://www.w3.org/2000/svg", "g");
        // 0: rotate
        const angle = this.placeholderMode ? 0 : parseInt(this.hexArray[0], 16);

        // big-1
        this.addCircleUseToGroup(group, idCircleBig, null, null, null, ``, color1, "", 0);
        // big-2
        this.addCircleUseToGroup(group, idCircleBig, null, null, null, `rotate(120,0,0)`, color2, "", 0);
        // big-3
        this.addCircleUseToGroup(group, idCircleBig, null, null, null, `rotate(240,0,0)`, color3, "", 0);

        // small-1
        const color4 = this.getColorHex(10, 11, 12);
        this.addUsePartToGroup(group, polygonId, "rotate(60,0,0)", color4, "", 0);
        // // small-2
        const color5 = this.getColorHex(13, 14, 15);
        this.addUsePartToGroup(group, polygonId, "rotate(180,0,0)", color5, "", 0);
        // // small-3
        const color6 = this.getColorHex(16, 17, 18);
        this.addUsePartToGroup(group, polygonId, "rotate(300,0,0)", color6, "", 0);

        group.setAttribute("transform", `rotate(${angle},${center},${center}) translate(${center} ${center})`);
        svg.appendChild(group);

        // sign
        const groupSign = document.createElementNS("http://www.w3.org/2000/svg", "g");
        const signColor1 = this.placeholderMode ? this.placeholderColor : this.getRGBAColorHex(8, 9, 10, 80);
        const size1 = 40, size2 = 16, dw = 24;
        const hw1 = 20, hw2 = 8;
        const points1: Array<Point> = [ new Point(-dw - hw2, -dw - hw2),
            new Point(hw2, -dw - hw2),
            new Point( hw2, hw2),
            new Point(-dw - hw2, hw2)
        ];
        const polygon1 = SvgUtils.createPolygonPath("", points1, false, signColor1, "", 0);
        groupSign.appendChild(polygon1);
        // sign-2
        const signColor2 = this.placeholderMode ? this.placeholderColor : this.getRGBAColorHex(11, 12, 13, 80);
        const points2: Array<Point> = [ new Point(-hw2, -hw2),
            new Point(hw2 + dw, -hw2),
            new Point(hw2 + dw, hw2 + dw),
            new Point(-hw2, hw2 + dw)
        ];
        const polygon2 = SvgUtils.createPolygonPath("", points2, false, signColor2, "", 0);
        groupSign.appendChild(polygon2);

        groupSign.setAttribute("transform", `translate(${center} ${center})`);
        svg.appendChild(groupSign);
        return svg;
    }

}